const DOMAIN_SEARCH_PAGE = "domainSearch";
const VPS_PAGE = "vps";

// TODO: These cases deserve to be better systemized.
// The VPS conditions cover the following:
// 1. if "vps" search param is present default to the VPS page.
// 2. if not, default to "domainSearch" page if it's found in the localStorage
// 3. if not, check for different search params in the URL to decide which
// product need to be shown in the cart.
// 4. if no params are present, check what's the content of the cart set in the
// sessionStorage and if VPS plan is there, fallback to the VPS page.

// Flows in the UI:
// 1. Coming from the VPS verticals –> display VPS page.
// 2. Having VPS plan in the cart but coming from another product page –> display
// product specific orders in the cart.
// 3. Having VPS plan in the cart but coming from a domain search (front page)
// –> display domain search page.
// 4. Having VPS plan in the cart but coming from an unknown place —> display
// VPS page
function getShouldSetVPSPage(currentActivePage) {
  const searchParams = new URLSearchParams(window.location.search);
  // Check if VPS plan comes with the URL
  let hasVPSInURL = !!searchParams.get("vps");

  // If coming from the VPS vertical
  if (hasVPSInURL) {
    return true;
  } else {
    if (currentActivePage === DOMAIN_SEARCH_PAGE) {
      return false;
    }

    const keywordInURL = searchParams.get("keyword");
    const domainInURL = searchParams.get("domain");
    const planInURL = searchParams.get("plan");
    const addonInURL = searchParams.get("addon");
    // TODO: To be consistent keyword should be added as a search params
    const isKeywordPresent = window.localStorage.getItem("keyword") !== "";

    // If coming from another product vertical
    if (
      keywordInURL ||
      domainInURL ||
      planInURL ||
      addonInURL ||
      isKeywordPresent
    ) {
      return false;
    } else {
      const cartFromSession = JSON.parse(window.sessionStorage.getItem("cart"));

      // If not
      // Check if there is VPS plan in the cart stored in session
      // This covers the case when customers arrive from a place we don't control
      if (
        cartFromSession &&
        Array.isArray(cartFromSession.productPrices) &&
        cartFromSession.productPrices.length > 0
      ) {
        const hasVPSPlan = !!cartFromSession.productPrices[0].lines.find(
          ({ category }) =>
            category === "onevps-base-plan" ||
            category === "managed-onevps-base-plan",
        );
        return hasVPSPlan;
      } else {
        return false;
      }
    }
  }
}

export default function calculateActivePage(pageFromURL) {
  let currentActivePage = pageFromURL;

  // Set current active page to be "vps"
  if (!currentActivePage && getShouldSetVPSPage(currentActivePage)) {
    currentActivePage = VPS_PAGE;
    // If current active page is previously set to be "vps"
    // but should no longer be—clear the localStorage (default to domainSearch)
  } else if (
    currentActivePage === VPS_PAGE &&
    !getShouldSetVPSPage(currentActivePage)
  ) {
    currentActivePage = null;
  }

  // Default to domainSearch
  return currentActivePage || "domainSearch";
}
